module.exports = __webpack_public_path__ + "img/29.04b986d8.png";